import { render, staticRenderFns } from "./NewWhatsappForm.vue?vue&type=template&id=5dd065fc&"
import script from "./NewWhatsappForm.vue?vue&type=script&lang=ts&"
export * from "./NewWhatsappForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewWhatsappForm.vue?vue&type=style&index=0&id=5dd065fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports